import React, { useState, useEffect } from "react";
import axios from 'axios';
import { HiMiniUserGroup } from "react-icons/hi2";
import ConfirmDialog from "../../components/ToastNotification/ConfirmModal";
import { RiDeleteBin6Fill } from "react-icons/ri";
import ToastNotification from "../../components/ToastNotification/ToastNotification";
function ScheduleService() {
  const [searchTerm, setSearchTerm] = useState('');
  const [fetchQuick, setFetchQuick] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [toast, setToast] = useState({
    show: false,
    message: '',
    bg: 'success'
  });
  const showToast = (msg, bg = 'success') => {
    setToast({
      show: true,
      message: msg,
      bg
    });
  };
  const [confirmDialog, setConfirmDialog] = useState({
    show: false,
    title: '',
    message: '',
    onConfirm: null
  });
  const showConfirmDialog = ({
    title,
    message,
    onConfirm
  }) => {
    setConfirmDialog({
      show: true,
      title,
      message,
      onConfirm: () => {
        onConfirm();
        setConfirmDialog({
          ...confirmDialog,
          show: false
        });
      }
    });
  };
  const fetchQuickService = async () => {
    try {
      const res = await axios.get("https://api.sweepydo.in/fetch-all-quick-service");
      setFetchQuick(res.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchQuickService();
  }, []);
  const filteredData = Array.isArray(fetchQuick) ? fetchQuick.filter(itm => Object.values(itm).some(val => String(val).toLowerCase().includes(searchTerm.toLowerCase()))) : [];
  const parsedService = selectedRow?.service ? JSON.parse(selectedRow.service) : [];
  const parsedAddress = selectedRow?.address ? JSON.parse(selectedRow.address) : {};
  const handleDelete = async id => {
    try {
      await axios.delete(`https://api.sweepydo.in/delete-quick-service-history/${id}`);
      showToast("Work slot deleted successfully", 'success');
      fetchQuickService();
    } catch (err) {
      console.error("Error deleting role:", err);
      showToast("Failed to delete work slot", 'danger');
    }
  };
  return <div className="container-fluid mt-3" style={{
    minHeight: "100vh"
  }}>

            <h2 className="mb-4 text-white text-center">Service Schedule History</h2>

             <ToastNotification show={toast.show} message={toast.message} bg={toast.bg} onClose={() => setToast({
      ...toast,
      show: false
    })} />

            <div className="card shadow-lg border-0 p-3" style={{
      background: "var(--black)",
      borderRadius: "12px"
    }}>
                <div style={{
        background: "var(--black)",
        borderRadius: "12px",
        padding: "15px"
      }}>

                    <div className="card-header  d-flex justify-content-between align-items-center flex-wrap gap-2 py-4">

                        {/* Search */}
                        <input type="text" className="form-control w-auto p-2" placeholder="Search by name ,number..." style={{
            background: "#1e293b",
            color: "#fff",
            border: "1px solid #334155",
            minWidth: "250px"
          }} value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />

                        {/* Right Actions */}
                        <div className="d-flex gap-2">

                        </div>
                    </div>

                    <div className="table-responsive">
                        <table className="text-center" style={{
            width: "100%",
            borderCollapse: "collapse",
            color: "#fff"
          }}>

                            <thead>
                                <tr style={{
                backgroundColor: "var(--black2)"
              }}>
                                    <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>SN</th>
                                    <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>SERVICE ID</th>
                                    <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>USER NAME</th>
                                    <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>USER MOBILE</th>

                                    <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>SERVICE STATUS</th>


                                    <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>STAFF NAME</th>
                                    <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>STAFF MOBILE</th>

                                    <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>ALLOCATED ON </th>

                                    <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>COMPLETED ON</th>
                                    <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>ACTION</th>


                                </tr>
                            </thead>

{/* 
                            {filteredData.map((s, idx) => (
                                <React.Fragment key={s.id} >
                                    <tr
                                        style={{
                                            backgroundColor: "var(--black)",
                                            borderBottom: "1px solid rgba(255,255,255,0.06)",
                                            transition: "0.3s",
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = "var(--black2)";
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = "var(--black)";
                                        }}
 
                                    >
                                        <td style={{ padding: "18px", textAlign: "center", verticalAlign: "middle" }}>{idx + 1}</td>
                                        <td style={{ padding: "18px", textAlign: "center" }} >
                                            {`QSID${s.id}`}</td>
                                        <td style={{ padding: "18px", textAlign: "center" }} >{s.users_name}</td>
 
                                        <td style={{ padding: "18px", textAlign: "center" }} >{s.users_mobile}</td>
 
                                        <td style={{ padding: "18px", textAlign: "center" }}>{s.service_status}</td>
                                        <td style={{ padding: "18px", textAlign: "center" }}> {s.staff_name} </td>
                                        <td style={{ padding: "18px", textAlign: "center" }}>{s.staff_mobile} </td>
 
                                        <td style={{ padding: "18px", textAlign: "center" }}>{s.allot_on} </td>
                                        <td style={{ padding: "18px", textAlign: "center" }}>{s.completed_on} </td>
 
                                        <td>
                                            <button
                                                className="btn btn-sm btn-info"
                                                onClick={() => {
                                                    setSelectedRow(s);
                                                    setShowModal(true);
                                                }}
                                            >
                                                View
                                            </button>
 
                                              {s.service_status === "Pending" && (
                                              <RiDeleteBin6Fill
                                                size={20}
                                                cursor="pointer"
                                                title="Delete"
                                                className="mx-2 text-danger"
                                                onClick={() =>
                                                  showConfirmDialog({
                                                    title: "Delete work slot",
                                                    message: "Are you sure you want to delete this service ?",
                                                    onConfirm: () => handleDelete(s.id),
                                                  })
                                                }
                                              />
                                            )}
                                        </td>
 
                                    </tr>
 
 
                                </React.Fragment>
                            ))} */}

                        </table>
                    </div>
                </div>
                {showModal && selectedRow && <div className="modal fade show" style={{
        display: "block",
        background: "rgba(0,0,0,0.6)"
      }}>
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content" style={{
            backgroundColor: "var(--black)",
            color: "#fff",
            border: "1px solid #2d3748"
          }}>

                                {/* Header */}
                                <div className="modal-header">
                                    <h5 className="modal-title">Service Details</h5>
                                    <button className="btn-close" onClick={() => setShowModal(false)}></button>
                                </div>

                                {/* Body */}
                                <div className="modal-body bg-dark text-white">

                                    {/* USER */}
                                    <div className="p-3 mb-3 bg-dark border border-secondary rounded border-start border-info border-4">
                                        <h6 className="text-info">User Details</h6>
                                        <p><b>User:</b> {selectedRow.users_name}</p>
                                        <p><b>Mobile:</b> {selectedRow.users_mobile}</p>
                                    </div>

                                    {/* CONTACT */}
                                    <div className="p-3 mb-3 bg-dark border border-secondary rounded border-start border-secondary border-4">
                                        <h6 className="text-secondary">Contact Details</h6>
                                        <p><b>Contact Person:</b> {selectedRow.contact_name}</p>
                                        <p><b>Contact No:</b> {selectedRow.contact_no}</p>
                                    </div>

                                    {/* SERVICE */}
                                    <div className="p-3 mb-3 bg-dark border border-secondary rounded border-start border-info border-4">
                                        <h6 className="text-info">Service Details</h6>
                                        {parsedService.map((srv, i) => <div key={i}>
                                                <p><b>Name:</b> {srv.name}</p>
                                                <p><b>Price:</b> ₹{srv.sale_price}</p>
                                                <p><b>Duration:</b> {srv.mins} mins</p>
                                            </div>)}
                                    </div>

                                    {/* PAYMENT */}
                                    <div className="p-3 mb-3 bg-dark border border-secondary rounded border-start border-secondary border-4">
                                        <h6 className="text-secondary">Payment Details</h6>
                                        <p><b>Amount:</b> ₹{selectedRow.amount}</p>
                                        <p><b>Tax:</b> ₹{selectedRow.tax}</p>
                                        <p><b>Mode:</b> {selectedRow.pay_mode}</p>
                                        <p><b>Payment ID:</b> {selectedRow.pay_id}</p>
                                        <p>
                                            <b>Status:</b>{" "}
                                            <span className={selectedRow.pay_status?.toLowerCase().includes("success") ? "text-success fw-bold" : "text-danger fw-bold"}>
                                                {selectedRow.pay_status}
                                            </span>
                                        </p>
                                          <p><b>Received Date:</b> {selectedRow.receive_on}</p>
                                         <p><b>Received Status:</b> {selectedRow.receive_status}</p>
                                    </div>

                                    {/* ADDRESS */}
                                    <div className="p-3 mb-3 bg-dark border border-secondary rounded border-start border-info border-4">
                                        <h6 className="text-info">Address</h6>
                                        <p>{parsedAddress.name}</p>
                                        <p>{parsedAddress.locality}, {parsedAddress.state}</p>
                                        <p>{parsedAddress.country} - {parsedAddress.pincode}</p>
                                    </div>

                                    {/* STATUS */}
                                    <div className="p-3 mb-3 bg-dark border border-secondary rounded border-start border-secondary border-4">
                                        <h6 className="text-secondary">Service Status</h6>
                                        <p><b>Status:</b> {selectedRow.service_status}</p>
                                       
                                    </div>

                                </div>

                                {/* Footer */}
                                <div className="modal-footer">
                                    <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
                                        Close
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>}


            </div>
             <ConfirmDialog show={confirmDialog.show} title={confirmDialog.title} message={confirmDialog.message} onConfirm={confirmDialog.onConfirm} onCancel={() => setConfirmDialog({
      ...confirmDialog,
      show: false
    })} />
        </div>;
}
export default ScheduleService;
